import { hasValue } from "@/utils/Helpers";
import classNames from "classnames";
import BFButton from "../../general/Button/BFButton";
import BfIcon from "../../icon/BfIcon";
import { DefaultIcons } from "../../icon/DefaultIcons";
import BFPageSwitch from "../../layout/page-switch/BFPageSwitch";
import { BFChooserOption } from "./BFChooser";
import "./BFChooserPage.scss";

interface BFChooserPageProps {
  onBack?: () => void;
  title: string;
  description?: string;

  options: BFChooserOption<string | Date | number>[];
  value?: string | number | Date;
  onChange: (value: string | number | Date) => void | Promise<void>;
  renderPage: (
    value: string | number | Date,
    goBack: () => void
  ) => React.ReactNode;

  relativeToFirstPage?: boolean;
}
const BFChooserPage = (props: BFChooserPageProps) => {
  return (
    <div className={classNames("bf-chooser-page")}>
      <BFPageSwitch
        relativeToFirstPage={props.relativeToFirstPage}
        renderPage1={(active) => (
          <div className={`chooser-page-container`}>
            <div className={classNames("bf-chooser-page-header")}>
              {props.onBack && (
                <div className={`bf-chooser-page-back`}>
                  <BFButton appearance="link" onClick={props.onBack}>
                    <BfIcon {...DefaultIcons.BACK} size={"xxs"} />
                  </BFButton>
                </div>
              )}
              <div className={classNames("bf-chooser-page-name __h3")}>
                {props.title}
              </div>
            </div>
            <div className={`chooser-scroller`}>
              <div className={`bf-chooser-page-description __sub-text`}>
                {props.description}
              </div>
              <div className={`bf-chooser-page-options`}>
                {props.options.map((entry) => (
                  <BFButton
                    key={entry.value.toString()}
                    className={`bf-chooser-page-option`}
                    appearance="default"
                    onClick={() => {
                      props.onChange(entry.value);
                    }}
                  >
                    <div className={`option-data`}>
                      <div className={`option-label`}>{entry.label}</div>
                      {entry.subLabel && (
                        <div className={`option-info __sub-text`}>
                          {entry.subLabel}
                        </div>
                      )}
                    </div>
                    <div className={`icon-wrapper`}>
                      <BfIcon {...DefaultIcons.CHEVRON_RIGHT} size={"xxs"} />
                    </div>
                  </BFButton>
                ))}
              </div>
            </div>
          </div>
        )}
        renderPage2={(active) =>
          props.renderPage(props.value, () => props.onChange(null))
        }
        switch={hasValue(props.value)}
      />
    </div>
  );
};

export default BFChooserPage;
